import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";

import ImagePicker from "../ImagePicker";
import { openModal, closeModal } from "../../../store/ducks/app";

import { commonWhite } from "../../../constants/colors";
import ImageContainer from "../ImageContainer";
import useMedia from "../../../hooks/useMedia";
import React from "react";
import useApp from "../../../hooks/useApp";
import { Pages } from "../../../constants/enums";


interface Props {
  label: string;
  attachment: any;
  changeAttachment: any;
  resource?:any;
  slug?:any;
}

const SetImage: React.FC<Props> = ({ label, attachment, changeAttachment ,resource,slug}) => {
  const dispatch = useDispatch();
  const userPermissions = useSelector(
    (state: any) => state.app.userPermissions
  );
  const { hasPermission } = useApp();
  const { mediaLibraryChangeSelected } = useMedia("mediaLibrary", "media");

  const handleEditImage = () => {
    if (hasPermission(userPermissions, "settings")) {
      dispatch(
        openModal(
          <ImagePicker
            title={label}
            attachment={attachment}
            changeAttachment={(attachment: any) => changeAttachment(attachment)}
            closeModal={() => {
              mediaLibraryChangeSelected(new Set());
              dispatch(closeModal());
            }}
            resource={resource}
            slug={slug}
          />
        )
      );
    }
  };

  return (
    <>
      {attachment &&  slug!==Pages.MENU_ITEMS && slug!==Pages.CATEGORIES?(
        <ImageContainer
          src={attachment.fileUrl}
          thumb={attachment.fileUrl}
          alt={attachment.alternativeText}
        />
      ):(attachment&&
        <ImageContainer
        src={attachment}
        thumb={attachment}
        alt={""}
      />
      )}
      <Button
        size="small"
        fullWidth
        disableRipple
        disableFocusRipple
        disableTouchRipple
        sx={{
          textDecoration: hasPermission(userPermissions, "settings")
            ? "underline"
            : "none",
          textTransform: "capitalize",
          border: (theme) => `1px solid ${theme.palette.divider}`,
          backgroundColor: (theme) => commonWhite(theme),
          borderTop: "none",
          p: 1,
          cursor: hasPermission(userPermissions, "settings")
            ? "pointer"
            : "initial",
          "&:hover": {
            background: "transparent",
            textDecoration: hasPermission(userPermissions, "settings")
              ? "underline"
              : "none",
          },
        }}
        onClick={handleEditImage}
      >
        {label}
      </Button>
    </>
  );
};

export default SetImage;
